import { gql } from '@apollo/client';

const translations = {
  GET_TRANSLATIONS: gql`
    query GetTranslations {
      translations {
        code
        value
      }
    }
  `,
};

export default translations;
